import { Text, View } from '@components/primitives';
import { useToast } from '@hooks';
import BPProductTile from '@molecules/BPProductTile';
import { NavigationProp } from '@react-navigation/native';
import appStyles from '@root/appStyles';
import { serverError } from '@utils/utils';
import React from 'react';
import styles from './styles';

interface BPProduct {
  id: number;
  name: string;
  iconLink?: string;
  icon: string;
  screenName: string;
  availability: boolean;
  canShowNew?: boolean;
}

interface BPCategory {
  category: {
    title: string;
    products: BPProduct[];
  };
}

interface APIError {
  message: string;
  statusCode?: number;
}

export function shouldShowProductTile(bpcategory: BPCategory, source: string) {
  return bpcategory.category.products.map(bpCategoryProducts => (
    <BPProductTile key={bpCategoryProducts.id} bpCategoryProducts={bpCategoryProducts} source={source} />
  ));
}

export function shouldRenderError(
  isError: boolean,
  error: APIError | null,
  toast: ReturnType<typeof useToast>,
  t: (key: string) => string,
  navigation: NavigationProp<any>,
  setInitialData: (data: any) => void,
) {
  if (isError && error) {
    serverError(error, toast, t, navigation, setInitialData);
  }
}

export function shouldShowProductCategoryList(bpProducts: BPCategory[], source: string) {
  return bpProducts.map(bpcategory => (
    <View key={bpcategory.category.title} style={[appStyles.marginHorizontal(15), styles.categoryContainer]}>
      <Text testID="categoryName" variant="lg-bold">
        {bpcategory.category.title}
      </Text>
      <View style={styles.productContainer}>{shouldShowProductTile(bpcategory, source)}</View>
    </View>
  ));
}

export function shouldSetBPListOnSuccess(
  isSuccess: boolean,
  data: { list?: BPCategory[] } | null,
  setBPProducts: React.Dispatch<React.SetStateAction<BPCategory[]>>,
) {
  if (isSuccess && data?.list) {
    setBPProducts(data.list);
  }
}
